import { render, staticRenderFns } from "./VaTreeNode.demo.vue?vue&type=template&id=035ec506&"
import script from "./VaTreeNode.demo.vue?vue&type=script&lang=js&"
export * from "./VaTreeNode.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports